import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import ParticipatedForms from '@/modules/covers/ParticipatedForms'
import { Stack } from 'expo-router'

export default function ParticipatedFormsPage() {
  const headerLeftItems = useWebBackButton('/forms')

  return (
    <>
      <Stack.Screen
        options={{
          title: '填表记录',
          ...buildScreenHeaderItems({ left: headerLeftItems }),
        }}
      />
      <ParticipatedForms />
    </>
  )
}
